import styled from 'styled-components';

export const UserMenuButtonWrapper = styled.button`
  all: unset;
`;
